// extracted by mini-css-extract-plugin
var _1 = "AcknowledgeBoxStyle-module__acknowledge-box___f3gDW";
var _2 = "AcknowledgeBoxStyle-module__acknowledge-box___f3gDW";
var _3 = "AcknowledgeBoxStyle-module__button____IRWm";
var _4 = "AcknowledgeBoxStyle-module__content___T_oCO";
var _5 = "AcknowledgeBoxStyle-module__text___ja__q";
export { _1 as "acknowledge-box", _2 as "acknowledgeBox", _3 as "button", _4 as "content", _5 as "text" }
